import { render, staticRenderFns } from "./StaticField.vue?vue&type=template&id=6b72af5a&scoped=true"
import script from "./StaticField.vue?vue&type=script&lang=js"
export * from "./StaticField.vue?vue&type=script&lang=js"


/* normalize component */
import normalizer from "!../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "6b72af5a",
  null
  
)

export default component.exports